"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSchema = void 0;
var _apis = require("../../common/apis");
var _schemaCalls = require("../../common/schemaCalls");
const getSchema = async () => {
  const response = await (0, _schemaCalls.getSchemaCall)(_apis.jwtRegisterSchemaUrl);
  return {
    type: response?.data?.type,
    properties: response?.data?.properties
  };
};
exports.getSchema = getSchema;